import * as React from 'react';

type Props = {
    footerPragraph1: string,
    footerPragraph2: string
}

//NoWalletButton コンポーネントの定義
export const SushiFooter: React.FC<Props> = (props) => {

  const sushiFooterStyle: React.CSSProperties = {
    textAlign:'center',
    bottom: 0,
    height: '60px',
    background: 'linear-gradient(107.31deg, rgba(239, 239, 239, 0.2) 5.23%, rgba(247, 247, 247, 0.2) 100%)',
    width: '100%',
    color:'white',
  };

  const sushiFooterImageStyle: React.CSSProperties = {
    width: '120px',
    display: 'unset',
  };
  const sushiFooterPragraph2Style: React.CSSProperties = {
    fontSize: '10px',
  };
  const sushiFooterPragraph1Style: React.CSSProperties = {
    marginBottom: '0px',
    fontSize: '10px'
  };
  return (
    <div>
        <footer style={sushiFooterStyle}>
            <div>
                <p className="footer-pragraph1" style={sushiFooterPragraph1Style}>{props.footerPragraph1}<img className="footer-img" style={sushiFooterImageStyle} src="https://nfttopshot-template.onrender.com/nandemolabostatic/img/footerlogo.png"/></p>
                <p className="footer-pragraph2" style={sushiFooterPragraph2Style}><strong>{props.footerPragraph2}</strong></p>                
            </div>
        </footer>
    </div>
  );
};